module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.phrases.current != null) ? _c('div', {
    attrs: {
      "id": "boards-list"
    }
  }, _vm._l((parseInt(_vm.count)), function(n) {
    return _c('div', {
      key: n,
      staticClass: "bingo-board-container"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "bingo-board"
    }, _vm._l((5), function(row) {
      return _c('ul', {
        key: row,
        staticClass: "bingo-row"
      }, _vm._l((5), function(col) {
        return _c('li', {
          key: col
        }, [_c('div', {
          staticClass: "hexagon-container"
        }, [_c('div', {
          staticClass: "hexagon-text"
        }, [_c('span', [_vm._v(_vm._s(_vm.getBoard(n)[(row - 1) * 5 + (col - 1)]))])]), _vm._v(" "), _c('div', {
          staticClass: "hexagon"
        })])])
      }))
    })), _vm._v(" "), _vm._m(1, true), _vm._v(" "), (n != _vm.count) ? _c('div', {
      staticClass: "page-break"
    }) : _vm._e()])
  })) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": "Heroes of the Storm"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "instructions"
  }, [_vm._v("\n      While you watch the "), _c('em', [_vm._v("Heroes of the Storm")]), _vm._v(", mark each hex as a caster says the indicated phrase. Be the first player to mark five hexes in a row (horizontal, vertical, or diagonal) and shout “"), _c('strong', [_vm._v("BINGO")]), _vm._v("” to win!\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e53d423c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BoardsList.vue
// module id = 18
// module chunks = 0